import {
  AccountListPage,
  RoleListPage,
  MenuListPage,
} from "@admin/pages/system-configure";
import type { RouteObject } from "react-router-dom";

const routes = [
  { path: "accounts", element: <AccountListPage /> },
  { path: "role", element: <RoleListPage /> },
  { path: "menu", element: <MenuListPage /> },
] satisfies RouteObject[];
export const systemConfigureRoute = {
  path: "system_configure",
  children: routes,
} satisfies RouteObject;
